import { createRoute, redirect } from '@tanstack/react-router';
import { authRoute } from '@/app/routes/roots';

// Preserve existing bookmarks while keeping one Settings hub.
export const userProfileRoute = createRoute({
  getParentRoute: () => authRoute,
  path: 'profile',
  beforeLoad: () => {
    throw redirect({
      to: '/settings',
      search: { tab: 'account' },
      replace: true,
    });
  },
});
